function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.0108 0L3.93548 7.05L0.989247 4.11429L0 5.1L3.44086 8.52857L3.93548 9L4.43011 8.52857L12 0.985714L11.0108 0Z",
  fill: "#414141"
});

function SvgSmallTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTick);
export default __webpack_public_path__ + "static/media/smallTick.81f2aabe4704ec1044fc175fdd30b813.svg";
export { ForwardRef as ReactComponent };